<h2 mat-dialog-title>Delete Additional Logo</h2>
<mat-dialog-content  >
  <h3>Do you want to delete ?</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="reset-btn">Cancel</button>
  <button mat-button class="done-btn" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>